import { render, staticRenderFns } from "./a.vue?vue&type=template&id=1c0e14de&scoped=true&"
var script = {}
import style0 from "./a.vue?vue&type=style&index=0&id=1c0e14de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e14de",
  null
  
)

export default component.exports